
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dGO9h", function(module, exports) {
/* CopySpacePermissionsForLegacyNewSpace.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $jTxSS = parcelRequire("jTxSS");


var $cgtv4 = parcelRequire("cgtv4");


var $euL71 = parcelRequire("euL71");


var $joCMa = parcelRequire("joCMa");


var $bQm3c = parcelRequire("bQm3c");


var $dsz8u = parcelRequire("dsz8u");


var $crGnL = parcelRequire("crGnL");

const $4baf451c3e5c454f$var$NEW_SPACE_LEGACY_DIALOG_ID = 'create-dialog';
const $4baf451c3e5c454f$var$NEW_SPACE_LEGACY_MAKE_PRIVATE_CHECKBOX_ID = 'permission-private';
const $4baf451c3e5c454f$var$NEW_SPACE_LEGACY_PERMISSIONS_SUBFORM_ID = 'space-form-permissions';
const $4baf451c3e5c454f$var$NEW_SPACE_LEGACY_TEAM_DESCRIPTION_ID = 'team-description';
const $4baf451c3e5c454f$var$NEW_SPACE_LEGACY_TEXTAREA_CSS_SELECTOR = `#${$4baf451c3e5c454f$var$NEW_SPACE_LEGACY_DIALOG_ID} textarea`;
const $4baf451c3e5c454f$var$NEW_SPACE_PERMISSIONS_ALL_FIELDS_VALID_ID = 'copy-space-permissions-fields-valid';
const $4baf451c3e5c454f$var$NEW_SPACE_PERMISSIONS_SOURCE_FIELD_ID = 'copy-space-permissions-key-for-create';
const $4baf451c3e5c454f$var$NEW_SPACE_PERMISSIONS_PORTAL_ID = 'new-space-permissions-portal-container';
const $4baf451c3e5c454f$var$TEAM_SPACE_TEMPLATE_TEAM_MEMBERS_ID = 'team-members';
const $4baf451c3e5c454f$var$CHANGE_LISTENER_CSS_CLASSNAME = 'portal-change-listener';
const $4baf451c3e5c454f$var$NEW_SPACE_LEGACY_TEAM_DESCRIPTION_MAX_ROWS = 2;
const $4baf451c3e5c454f$var$i18n = (0, $cgtv4.defineMessages)({
    optionSelectLabel: {
        id: "copy-space-permissions.for-new-space.option-select.label",
        defaultMessage: "Space permissions"
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4baf451c3e5c454f$var$CopySpacePermissionsPanel = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkv77o _kqswstnw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4baf451c3e5c454f$var$CopySpacePermissionsSubpanel = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqsw1n9t",
            __cmplp.className
        ])
    });
});
const $4baf451c3e5c454f$var$SpaceTemplateCssOverride = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("style", null, `
      /********************************************************************/
      /* Begin section for Copy Space Permissions on Create Space Dialog  */
      /********************************************************************/

      #${$4baf451c3e5c454f$var$NEW_SPACE_LEGACY_DIALOG_ID} .dialog-wizard-page-main {
        padding-top: 10px;
      }

      #${$4baf451c3e5c454f$var$NEW_SPACE_LEGACY_DIALOG_ID} .dialog-wizard-page-description {
        padding-top: 10px;
      }

      #${$4baf451c3e5c454f$var$NEW_SPACE_LEGACY_DIALOG_ID} .error {
        margin-top: 3px;
      }

      /* Force the Team Space Template's Team Member field to have maximum height of 2 rows.
        The unmodified version of this field has unlimited height, which gets ugly especially
        with the additional Copy Space Permissions now below it. */
      #${$4baf451c3e5c454f$var$NEW_SPACE_LEGACY_DIALOG_ID} ul.select2-choices {
        max-height: 54px;
        overflow: auto;
      }
   `);
const $4baf451c3e5c454f$var$getObjectConstructorName = (object)=>object?.constructor?.name;
const $4baf451c3e5c454f$export$5dc791f41eb205df = ()=>{
    /* Keep track of whether the Create New Space wizard has been displayed yet. This is done for
     efficiency, so we don't have to search the DOM for the portal target if that wizard hasn't been
     shown yet.  However, once the wizard is exited this state does not get reset until the page is
     refreshed */ const [targetWizardActivated, setTargetWizardActivated] = (0, $42omo.useState)(false);
    const [, setLastRefresh] = (0, $42omo.useState)(0);
    const forceUpdate = ()=>{
        setLastRefresh(Date.now());
    };
    /* Passes the source Space key to the server-side rendered (SSR) part of the page by changing
     the value of a hidden field on the SSR side, which the SSR Javascript code will read and add
     to the Create New Space request to the backend */ const setCreateSpaceSourceKeyInSSR = (sourceSpaceKey)=>{
        const sourceField = document.getElementById($4baf451c3e5c454f$var$NEW_SPACE_PERMISSIONS_SOURCE_FIELD_ID);
        if ($4baf451c3e5c454f$var$getObjectConstructorName(sourceField) === 'HTMLInputElement') {
            const sourceInputField = sourceField;
            sourceInputField.value = sourceSpaceKey;
        }
    };
    /* Updates the hidden "copy-space-permissions-fields-valid" field on the legacy (SSR) side of
     the page to indicate whether the React-based controls have valid settings */ const setReactFieldsValidInSSR = (option, sourceSpace)=>{
        const legacySpacePermissionsValidField = document.getElementById($4baf451c3e5c454f$var$NEW_SPACE_PERMISSIONS_ALL_FIELDS_VALID_ID);
        if ($4baf451c3e5c454f$var$getObjectConstructorName(legacySpacePermissionsValidField) === 'HTMLInputElement') {
            // Set the value in the SSR field
            // (Any non-empty string value means "valid")
            const inputField = legacySpacePermissionsValidField;
            inputField.value = option && (0, $dsz8u.isSourceSpaceValid)({
                option: option,
                sourceSpace: sourceSpace
            }) ? 'true' : ''; // Tell the legacy UI code that the validity field has changed
            // (Note that while IE 11 doesn't support CustomEvent constructors, our main webpack config has the "events-polyfill" included)
            inputField.dispatchEvent(new CustomEvent('change', {
                bubbles: true
            }));
        }
    };
    /* We have to hide the "permission-private" checkbox and its' label, etc. every time we render our new UI
     because when this component's render is called we know that the SSR target has re-rendered and made the
     checkbox is visible again */ const hideCreateSpaceOldPermissions = ()=>{
        const oldPermissions = document.getElementById($4baf451c3e5c454f$var$NEW_SPACE_LEGACY_PERMISSIONS_SUBFORM_ID);
        if (oldPermissions) oldPermissions.classList.add('hidden');
    };
    /* The different Space templates' SSR wizard pages may have a "description" or other textarea
     controls on them that by default are resizable - but because our React component will float
     over the SSR wizard page (so our dropdowns don't get cut off by "overflow: hidden") the
     textareas could be resized underneath our React component.  This method finds any such
     textareas and makes them fixed-size - which is okay because they will still scroll if the
     user types too much in them */ const lockCreateSpaceTextareasSize = ()=>{
        document.querySelectorAll($4baf451c3e5c454f$var$NEW_SPACE_LEGACY_TEXTAREA_CSS_SELECTOR).forEach((element)=>{
            if ($4baf451c3e5c454f$var$getObjectConstructorName(element) === 'HTMLTextAreaElement') {
                const textareaElement = element;
                textareaElement.style.resize = 'none';
            }
        });
    };
    /* On SSR wizard page for the Team Space template, when the user chooses to add a team member
     to the template the control for the team members grows and then shrinks back again. Our
     portal gets re-rendered when the it the team members control grows (and our fields are psuhed
     down) but it is not re-rendered when it shrinks again.  This leaves a gap between the existing
     fields and our fields, and may also push our fields off the bottom of the dialog (especially
     if there are error messages visible).  We can hook into the events generated by the team
     member control to force a re-render when the selection is done. */ /* Note that the team member control is a very old AUI component "user-group-select2" component
     found in the "confluence-ui-components" repo, so modifying the control itself to not expand-
     then-shrink seems risky.  And while this component is built on top of "Select2", which is an
     old jQuery replacement for the standard HTML <select> control.  But as the AUI user group
     control doesn't user all of the Select control functionally (the list of names isn't actually
     in the Select2 control's dropdown; AUI has created a separate div for that), we can't listen
     for the standard "select2-selected" event.  Instead we listen for when the contents of the
     controls changes */ const renderOnTeamTemplateMembersChange = ()=>{
        // Use an empty CSS class as a flag to indicate whether we've already connected the listener
        const teamMembersControl = document.getElementById($4baf451c3e5c454f$var$TEAM_SPACE_TEMPLATE_TEAM_MEMBERS_ID);
        if (teamMembersControl && !teamMembersControl.classList.contains($4baf451c3e5c454f$var$CHANGE_LISTENER_CSS_CLASSNAME)) {
            teamMembersControl.classList.add($4baf451c3e5c454f$var$CHANGE_LISTENER_CSS_CLASSNAME);
            teamMembersControl.onchange = ()=>forceUpdate();
        }
    };
    /* We also need to adjust the Team Space Template's "Description" field's height or the portal
     may get rendered past the end of the dialog */ const adjustTeamTemplateDescriptionSize = ()=>{
        const teamTemplateDesciption = document.getElementById($4baf451c3e5c454f$var$NEW_SPACE_LEGACY_TEAM_DESCRIPTION_ID);
        if ($4baf451c3e5c454f$var$getObjectConstructorName(teamTemplateDesciption) === 'HTMLTextAreaElement') {
            const teamDescriptionTextarea = teamTemplateDesciption;
            teamDescriptionTextarea.rows = $4baf451c3e5c454f$var$NEW_SPACE_LEGACY_TEAM_DESCRIPTION_MAX_ROWS;
        }
    };
    /* Move the portal target to be the last sibling in its' parent's list of children.  This is
     a hack to make components rendered into the portal appear after any other child elements,
     as some of the Space templates call the "createSpaceFormFields" template (which contains
     our portal target) and then add their extra fields after that - but our UI designers want
     our new added components to be last in the form.  And since most of the Space templates
     are plugins in other repos (and others may be added at any time) we have no easy way to
     add our portal to all of them. Therefore at runtime we'll just make sure our portal
     target is after everything else in the parent form */ const makePortalTargetLastSibling = ()=>{
        const portalTarget = document.getElementById($4baf451c3e5c454f$var$NEW_SPACE_PERMISSIONS_PORTAL_ID);
        if (portalTarget) {
            const parent = portalTarget.parentElement;
            if (parent) parent.appendChild(portalTarget);
        }
    };
    /* Passes the "make private" flag to the server-side rendered (SSR) part of the page by changing
     the value of a hidden checkbox on the SSR side, which the SSR Javascript code will read and add
     to the Create New Space request to the backend */ const setMakePrivateInSSR = (makePrivate)=>{
        const privateCheckbox = document.getElementById($4baf451c3e5c454f$var$NEW_SPACE_LEGACY_MAKE_PRIVATE_CHECKBOX_ID);
        if ($4baf451c3e5c454f$var$getObjectConstructorName(privateCheckbox) === 'HTMLInputElement') {
            const privateCheckboxInput = privateCheckbox;
            privateCheckboxInput.checked = makePrivate;
        }
    };
    const onChange = ({ option: option, sourceSpace: sourceSpace })=>{
        /* When the "make private" flag changes, pass the flag to its' hidden field on the SSR side of the page */ setMakePrivateInSSR(option === (0, $crGnL.Option).ONLY_VISIBLE_TO_ME); /* Because we are passing the selected source Space's key to the SSR side of the page in a
                                                                 hidden field on the SSR side, we need to copy the current setting to the SSR field when
                                                                 copying is selected and make sure to clear the SSR field's value when deselected */ 
        setCreateSpaceSourceKeyInSSR(sourceSpace.key); // Update the enable state of legacy UI's "Create" button based the validity of our fields
        setReactFieldsValidInSSR(option, sourceSpace);
    };
    const newSpaceWizardMessageHandler = (0, $42omo.useCallback)(()=>{
        /* If we haven't already seen the portal target yet, check if this is a wizard page with
        our portal target on it */ if (!targetWizardActivated && document.getElementById($4baf451c3e5c454f$var$NEW_SPACE_PERMISSIONS_PORTAL_ID)) setTargetWizardActivated(true);
         // Always force a re-render, as React won't recognize when the SSR part of the page redraws
        forceUpdate();
    }, [
        targetWizardActivated
    ]);
    // Customize the legacy SSR after every render for our new UI elements, if our portal target is visible
    (0, $42omo.useEffect)(()=>{
        if (targetWizardActivated && document.getElementById($4baf451c3e5c454f$var$NEW_SPACE_PERMISSIONS_PORTAL_ID)) {
            hideCreateSpaceOldPermissions();
            makePortalTargetLastSibling();
            lockCreateSpaceTextareasSize();
            adjustTeamTemplateDescriptionSize();
            renderOnTeamTemplateMembersChange();
        }
    });
    /* The Create New Space wizard is rendered dynamically on the browser at runtime (even though
     the Javascript code to do so is in the server-rendered pages) and that means we won't find
     the portal target on this page during the initial React render.  And since the wizard is
     plain Javascript, the React component tree does not get notified or re-rendered when the
     wizard is displayed.  So we need to have the wizard tell us when it has been rendered via
     the legacy-message-queue. This hook sets up the message handler for that event, so it only
     needs to be called once, at initialization time. But added newSpaceWizardMessageHandler to
     dependency array for eslint purposes */ /* (Note that this component needs to in the DOM tree in classic:SPA pages, next:SPA pages
     and SSR pages, since there are "Create new space" buttons on the "Space Directory" page
     which is an SSR page, and on the "Activity" ("/discover" route) page which is a SPA page,
     and new "Home" page ("/wiki" route) */ (0, $42omo.useEffect)(()=>{
        // set the callback for when the Create New Space wizard is rendered
        (0, $joCMa.getLegacyMessageQueue)().then((legacyMessageQueue)=>{
            legacyMessageQueue.push({
                type: 'ATLASSIAN_CONFLUENCE_NEW_SPACE_REGISTER_CALLBACK',
                payload: newSpaceWizardMessageHandler
            });
        });
    }, [
        newSpaceWizardMessageHandler
    ]);
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    if (targetWizardActivated) {
        const portalTarget = document.getElementById($4baf451c3e5c454f$var$NEW_SPACE_PERMISSIONS_PORTAL_ID);
        if (portalTarget) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(edition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4baf451c3e5c454f$var$CopySpacePermissionsPanel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4baf451c3e5c454f$var$CopySpacePermissionsSubpanel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dsz8u.CopySpacePermissionsSelector), {
            analyticsEventSourceName: "createSpaceModal",
            defaultOption: (0, $crGnL.Option).DEFAULT_PERMISSIONS,
            isDisabled: edition === (0, $euL71.ConfluenceEdition).FREE,
            label: $4baf451c3e5c454f$var$i18n.optionSelectLabel,
            onChange: onChange,
            options: (0, $crGnL.getOptionsByEdition)(edition),
            showUpsell: edition === (0, $euL71.ConfluenceEdition).STANDARD,
            renderGuestsWarning: true,
            validationPlaceholder: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4baf451c3e5c454f$var$SpaceTemplateCssOverride, null)) : null, portalTarget);
    }
    // If we couldn't render into the portal target or didn't need to, then don't render anything
    return null;
};
module.exports["CopySpacePermissionsForLegacyNewSpace"] = $4baf451c3e5c454f$export$5dc791f41eb205df;

});

parcelRegister("eWRwJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca4f3d8c1426d3d8$export$2e2bcd8739ae039);
var $ca4f3d8c1426d3d8$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("4WmbV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $hArLp = parcelRequire("hArLp");

var $eEA8O = parcelRequire("eEA8O");


var $1ytiN = parcelRequire("1ytiN");


var $iJ9aA = parcelRequire("iJ9aA");


var $ki6F7 = parcelRequire("ki6F7");


var $k4Vdy = parcelRequire("k4Vdy");


var $iC1wS = parcelRequire("iC1wS");


var $lNKOh = parcelRequire("lNKOh");


var $bhvFb = parcelRequire("bhvFb");


var $9wGTI = parcelRequire("9wGTI");


var $cHKtk = parcelRequire("cHKtk");


var $kpYGL = parcelRequire("kpYGL");

var $3a454656eb0e87cd$export$d33a80488b9cab17 = /*#__PURE__*/ function(SectionMessageButtonConfig) {
    SectionMessageButtonConfig["DEFAULT"] = "default";
    SectionMessageButtonConfig["UPGRADE_ONLY"] = "upgradeOnly";
    SectionMessageButtonConfig["NONE"] = "none";
    return SectionMessageButtonConfig;
}({});
const $3a454656eb0e87cd$export$2e68cfab3dc25476 = ({ canShowUpgradeButton: canShowUpgradeButton = true, buttonConfig: buttonConfig = "default", upgradeEditionActionSubjectId: upgradeEditionActionSubjectId = 'freeTryNow', grandfathered: grandfathered, source: source, onUpFlowOpen: onUpFlowOpen, secondaryLink: secondaryLink, targetEdition: targetEdition, learnMoreLink: learnMoreLink, footer: footer, headerButton: headerButton, showRequestUpgradeButton: showRequestUpgradeButton = false, showRequestUpgradeButtonAATest: showRequestUpgradeButtonAATest = false, isLoadingRequestUpgradeButton: isLoadingRequestUpgradeButton = false, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const CTAAnalyticsAttributes = (0, $42omo.useMemo)(()=>{
        return {
            isSiteAdmin: isSiteAdmin,
            isGrandfathered: Boolean(grandfathered)
        };
    }, [
        grandfathered,
        isSiteAdmin
    ]);
    const generateCTAAnalyticsProps = (actionSubjectId)=>({
            actionSubjectId: actionSubjectId,
            source: source,
            attributes: CTAAnalyticsAttributes
        });
    const triggerLinkClickAnalytics = (clickEventActionSubjectId, linkMessage)=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: clickEventActionSubjectId,
                source: source,
                attributes: {
                    ...CTAAnalyticsAttributes,
                    linkMessage: linkMessage
                }
            }
        }).fire();
    };
    const handleSecondaryLinkClick = ()=>{
        const link = secondaryLink;
        if (link) {
            triggerLinkClickAnalytics(link.actionSubjectId, link.messageDescriptor.defaultMessage);
            if (typeof link.onClick === 'function') link.onClick();
        }
    };
    (0, $42omo.useEffect)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'changeEditionGatewayScreen',
                attributes: {
                    ...CTAAnalyticsAttributes,
                    source: source
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        CTAAnalyticsAttributes,
        source
    ]);
    const renderButtons = ()=>{
        if (isLoadingRequestUpgradeButton && (0, $9wGTI.fg)('connie_end_user_request_kill_switch')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "200px",
            height: "32px"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lNKOh.ChangeEditionSectionMessageButtonsWrapper), {
            isSiteAdmin: isSiteAdmin,
            canShowUpgradeButton: canShowUpgradeButton,
            shouldShowLearnMore: !Boolean(secondaryLink),
            showRequestUpgradeButton: showRequestUpgradeButton
        }, ({ showUpgradeTryNowButton: showUpgradeTryNowButton, showLearnMore: showLearnMore, learnMoreIsPrimaryCTA: learnMoreIsPrimaryCTA })=>{
            //
            // primary
            //
            let primary;
            const upgradeEditionButton = showUpgradeTryNowButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ki6F7.UpgradeEditionButton), {
                analyticsProps: generateCTAAnalyticsProps(upgradeEditionActionSubjectId),
                onUpFlowOpen: onUpFlowOpen,
                targetEdition: targetEdition,
                ...props
            }) : null;
            if (upgradeEditionButton) primary = upgradeEditionButton;
            else if (showRequestUpgradeButton && (0, $9wGTI.fg)('connie_end_user_request_kill_switch')) primary = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cHKtk.EndUserRequestUpgradeButton), {
                source: source
            });
            else if (showRequestUpgradeButtonAATest && (0, $9wGTI.fg)('connie_end_user_request_kill_switch')) primary = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null);
            //
            // secondaries
            //
            let secondaries;
            if (buttonConfig !== "upgradeOnly" || !isSiteAdmin) {
                // If the 'Try it free/now' button is to be shown, but it is not the
                // primary CTA, then make sure its appearance is appropriate for a
                // secondary:
                if (upgradeEditionButton && primary !== upgradeEditionButton) secondaries = [
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(upgradeEditionButton, {
                        appearance: 'link'
                    })
                ];
                else secondaries = getSecondaries(showLearnMore, learnMoreIsPrimaryCTA);
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, primary, secondaries);
        });
    };
    const getSecondaries = (showLearnMore, learnMoreIsPrimaryCTA)=>{
        const withIcon = Boolean(learnMoreLink?.icon);
        const learnMoreAppearance = withIcon || learnMoreIsPrimaryCTA ? learnMoreLink?.appearance || 'default' : 'link';
        const learnMoreButton = showLearnMore ? renderLearnMoreLink({
            appearance: learnMoreAppearance
        }) : null;
        const secondaryLinkComponent = secondaryLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            key: "secondLink",
            appearance: secondaryLink.appearance || 'default',
            href: secondaryLink.href ? secondaryLink.href : undefined,
            id: "secondaryLink",
            spacing: "default",
            target: secondaryLink.target || '_blank',
            onClick: handleSecondaryLinkClick,
            testId: (0, $k4Vdy.calculateTestId)({
                source: source,
                actionSubjectId: secondaryLink.actionSubjectId
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), secondaryLink.messageDescriptor)) : null;
        return secondaryLink?.appearance === 'primary' && learnMoreAppearance !== 'primary' ? [
            secondaryLinkComponent,
            learnMoreButton
        ] : [
            learnMoreButton,
            secondaryLinkComponent
        ];
    };
    const renderLearnMoreLink = ({ children: children, ...learnMoreProps })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJ9aA.LearnMoreButton), {
            key: "learnMore",
            analyticsProps: generateCTAAnalyticsProps(learnMoreLink?.actionSubjectId || 'freeLearnMore'),
            appearance: learnMoreLink?.appearance || 'default',
            onUpFlowOpen: onUpFlowOpen,
            targetEdition: targetEdition,
            inProductHelpId: learnMoreLink?.inProductHelpId,
            inProductHelpTopic: learnMoreLink?.inProductHelpTopic,
            href: learnMoreLink?.href,
            icon: learnMoreLink?.icon,
            ariaLabel: learnMoreLink?.ariaLabel,
            ...learnMoreProps,
            onClick: learnMoreLink?.onClick
        }, children !== undefined ? children : learnMoreLink?.messageDescriptor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), learnMoreLink.messageDescriptor) : undefined);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bhvFb.EditionSectionMessage), {
        actions: buttonConfig !== "none" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, renderButtons()) : undefined,
        edition: targetEdition,
        footer: isSiteAdmin && footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, footer) : null,
        headerButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, headerButton),
        ...props
    });
};
module.exports["SectionMessageButtonConfig"] = $3a454656eb0e87cd$export$d33a80488b9cab17;
module.exports["ChangeEditionSectionMessage"] = $3a454656eb0e87cd$export$2e68cfab3dc25476;

});

parcelRegister("lNKOh", function(module, exports) {
const $5ea77288491beecf$export$2321d4fb07b49d13 = ({ canShowUpgradeButton: canShowUpgradeButton, children: children, isSiteAdmin: isSiteAdmin, shouldShowLearnMore: shouldShowLearnMore = true, showRequestUpgradeButton: showRequestUpgradeButton })=>{
    let showUpgradeTryNowButton = false;
    let showLearnMore = true;
    let learnMoreIsPrimaryCTA = true;
    if (canShowUpgradeButton) {
        if (isSiteAdmin) showUpgradeTryNowButton = true;
        if (showUpgradeTryNowButton) {
            // NOTE: Don't show 'Learn More' CTA if it will appear in between the
            // Upgrade Edition button and a secondary feature link (like
            // "Remove this page's restrictions" button). In those cases, "Learn
            // More" CTA will be displayed at the end of the general text content,
            // outside of this component.
            showLearnMore = shouldShowLearnMore;
            learnMoreIsPrimaryCTA = false;
        }
    }
    if (showRequestUpgradeButton) // If an end user request upgrade button is present,
    // we don't show the learn more link if it's not specifically provided.
    showLearnMore = shouldShowLearnMore;
    return children({
        showUpgradeTryNowButton: showUpgradeTryNowButton,
        showLearnMore: showLearnMore,
        learnMoreIsPrimaryCTA: learnMoreIsPrimaryCTA
    });
};
module.exports["ChangeEditionSectionMessageButtonsWrapper"] = $5ea77288491beecf$export$2321d4fb07b49d13;

});

parcelRegister("w033M", function(module, exports) {
const $ea2c8f52a33264f1$export$4782acb2cb5b7c11 = (queryData)=>Boolean(queryData?.isSiteAdmin);
module.exports["getIsSiteAdminFromQuery"] = $ea2c8f52a33264f1$export$4782acb2cb5b7c11;

});

parcelRegister("eJhXX", function(module, exports) {

var $fWkVZ = parcelRequire("fWkVZ");


var $w033M = parcelRequire("w033M");


var $icMDs = parcelRequire("icMDs");

function $a7000458c02582d2$export$d036114e4ad5c4c3(queryData) {
    const isSiteAdmin = (0, $w033M.getIsSiteAdminFromQuery)(queryData);
    const isProductAdmin = (0, $fWkVZ.getIsProductAdminFromQuery)(queryData);
    return typeof queryData === 'undefined' ? undefined : isSiteAdmin ? (0, $icMDs.UserPrivilege).SITE_ADMIN : isProductAdmin ? (0, $icMDs.UserPrivilege).PRODUCT_ADMIN : (0, $icMDs.UserPrivilege).NON_ADMIN;
}
module.exports["getUserPrivilegeFromQuery"] = $a7000458c02582d2$export$d036114e4ad5c4c3;

});

parcelRegister("fWkVZ", function(module, exports) {
const $b7fc105cb96f63fd$export$7ed4faccc7e85b7f = (queryData)=>Boolean(queryData?.user?.confluence?.operations?.some((o)=>o?.operation === 'administer' && o?.targetType === 'application'));
module.exports["getIsProductAdminFromQuery"] = $b7fc105cb96f63fd$export$7ed4faccc7e85b7f;

});

parcelRegister("icMDs", function(module, exports) {
var $296e2d91f769f195$export$fa8745fb6d256802 = /*#__PURE__*/ function(UserPrivilege) {
    UserPrivilege["NON_ADMIN"] = "nonAdmin";
    UserPrivilege["PRODUCT_ADMIN"] = "productAdmin";
    UserPrivilege["SITE_ADMIN"] = "siteAdmin";
    return UserPrivilege;
}({});
module.exports["UserPrivilege"] = $296e2d91f769f195$export$fa8745fb6d256802;

});

parcelRegister("gLeLL", function(module, exports) {
/* SectionMessage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $j4WDj = parcelRequire("j4WDj");


var $4WmbV = parcelRequire("4WmbV");

const $103cc6a380e10ff8$export$a36903bd214cec06 = ({ children: children, withGradient: withGradient = true, topBanner: // TODO: refactor topBanner and customPadding per https://product-fabric.atlassian.net/browse/USD-337
// for now since we only support 2 different cases, we give a boolean, going forward, if more use cases surface, we can revisit and design a better API
topBanner = false, customPadding: customPadding, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($103cc6a380e10ff8$var$Layout, {
        withGradient: withGradient,
        topBanner: topBanner,
        customPadding: customPadding,
        "data-testid": "section-message"
    }, !!children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($103cc6a380e10ff8$var$ChildrenLayout, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        ...props,
        withTasteAndToneStyling: true
    }));
const $103cc6a380e10ff8$var$ChildrenLayout = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2hwx1ejb _p12f68cl _1ul968cl",
            __cmplp.className
        ])
    });
});
const $103cc6a380e10ff8$var$gradientBackground = `linear-gradient(84.09deg,
  ${(0, $j4WDj.GRADIENT_BACKGROUND_SUBTLEST_START)} 0%,
  ${(0, $j4WDj.GRADIENT_BACKGROUND_SUBTLEST_END)} 100%)`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $103cc6a380e10ff8$var$Layout = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { withGradient: withGradient, customPadding: customPadding, topBanner: topBanner, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1p4ue13": (0, $7sObp.default)($103cc6a380e10ff8$var$gradientBackground),
            "--_krzptn": (0, $7sObp.default)((()=>{
                if (__cmplp.customPadding) return __cmplp.customPadding;
                if (__cmplp.topBanner) return `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"}`;
                return `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-300, 24px)"}`;
            })())
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1yt41r3g _2rko12b0 _1e0c1txw _1bsb1osq _vchhusvi _kqswh2mm",
            __cmplp.withGradient ? "_11q7hu7i" : "_11q7glyw",
            __cmplp.className
        ])
    });
});
module.exports["SectionMessage"] = $103cc6a380e10ff8$export$a36903bd214cec06;

});

parcelRegister("iquRY", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $24WXz = parcelRequire("24WXz");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $cccaa992351fdb79$export$dcac763621aee435 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(6);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== cloudId) {
        t0 = {
            variables: {
                cloudId: cloudId
            },
            onError: $cccaa992351fdb79$var$_temp
        };
        $[0] = cloudId;
        $[1] = t0;
    } else t0 = $[1];
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $24WXz.default), t0);
    const isNotPreRoles = data?.confluence_spaceRoleMode ? data.confluence_spaceRoleMode !== "PRE_ROLES" : false;
    const t1 = data?.confluence_spaceRoleMode;
    let t2;
    if ($[2] !== isNotPreRoles || $[3] !== loading || $[4] !== t1) {
        t2 = {
            spaceRoleMode: t1,
            isRbacEnabled: isNotPreRoles,
            loading: loading
        };
        $[2] = isNotPreRoles;
        $[3] = loading;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $24WXz.default), {
        variables: {
            cloudId: cloudId
        },
        onError: (error)=>{
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    });
    const isNotPreRoles = data?.confluence_spaceRoleMode ? data.confluence_spaceRoleMode !== 'PRE_ROLES' : false;
    return {
        spaceRoleMode: data?.confluence_spaceRoleMode,
        isRbacEnabled: isNotPreRoles,
        loading: loading
    };
};
function $cccaa992351fdb79$var$_temp(error) {
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
    });
    (0, $7Sm4c.markErrorAsHandled)(error);
}
module.exports["useSpaceRoleMode"] = $cccaa992351fdb79$export$dcac763621aee435;

});

parcelRegister("24WXz", function(module, exports) {
/**
 * @generated SignedSource<<fca40edcd431a6c5f3bb28df1ad0109c>>
 * @relayHash 60ed41889a4cd98154a0419dcf1f59f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82
const $016cc5cc0310f39a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_spaceRoleMode"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "60ed41889a4cd98154a0419dcf1f59f5",
            "id": "568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82",
            "metadata": {},
            "name": "useSpaceRoleModeQuery",
            "operationKind": "query",
            "text": "query useSpaceRoleModeQuery($cloudId:ID!){confluence_spaceRoleMode(cloudId:$cloudId)}"
        }
    };
}();
$016cc5cc0310f39a$var$node.hash = "88c4ae8983cc6692099b2b1e1d7a4379";
var $016cc5cc0310f39a$export$2e2bcd8739ae039 = $016cc5cc0310f39a$var$node;
module.exports["default"] = $016cc5cc0310f39a$export$2e2bcd8739ae039;

});

parcelRegister("caYQd", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $jmjWc = parcelRequire("jmjWc");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a745dfd537cdace3$var$LoadingSpaceSelector = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1tke1ylp",
            __cmplp.className
        ])
    });
});

const $a745dfd537cdace3$export$ae81af835e192ac4 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "SLEHS",
    name: "SpaceSelector",
    loader: async ()=>(await (parcelRequire("gTTf6"))).SpaceSelector,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a745dfd537cdace3$var$LoadingSpaceSelector, null)
});
module.exports["SpaceSelector"] = $a745dfd537cdace3$export$ae81af835e192ac4;

});

parcelRegister("gTTf6", function(module, exports) {

let $c4dca270a2817a23$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c4dca270a2817a23$var$load("lnnYm"),
    $c4dca270a2817a23$var$load("6wr18"),
    $c4dca270a2817a23$var$load("2mt3f"),
    $c4dca270a2817a23$var$load("ffEVr"),
    $c4dca270a2817a23$var$load("jXx9i"),
    $c4dca270a2817a23$var$load("fjNm1"),
    $c4dca270a2817a23$var$load("eKPux"),
    $c4dca270a2817a23$var$load("iZU4p"),
    $c4dca270a2817a23$var$load("jlSv2"),
    $c4dca270a2817a23$var$load("1UUrt"),
    $c4dca270a2817a23$var$load("kWZnd"),
    $c4dca270a2817a23$var$load("92LGf"),
    $c4dca270a2817a23$var$load("iqKwT"),
    $c4dca270a2817a23$var$load("jyfIr"),
    $c4dca270a2817a23$var$load("7EorR"),
    $c4dca270a2817a23$var$load("kUbUu"),
    $c4dca270a2817a23$var$load("hhss7"),
    $c4dca270a2817a23$var$load("h3ABO"),
    $c4dca270a2817a23$var$load("kC80R"),
    $c4dca270a2817a23$var$load("eMbU0")
]).then(()=>parcelRequire('bHtQ2'));

});


//# sourceMappingURL=CopySpacePermissionsForLegacyNewSpace.636ec622.js.map
